/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React,{useState,useEffect} from 'react'
import ReactModal from 'react-modal'
import OfferToolTip from '../OfferToolTip'
import AddressChangeModal from './AddressChangeModal'
import { AddressDrop } from './AddressDrop'
import { motion } from 'framer-motion'
import Toggle from 'react-toggle'
import "react-toggle/style.css" // for ES6 modules
import ItemPriceTooltip from '../ItemPriceTooltip';

import './style.css'
const spring = {
    type: 'spring',
    stiffness: 700,
    damping: 30,
};

export default function AddressSelectionCard(
    {
        prod,
        addressDropdown,
        handleDiscount,
        selectedAddressObj,idx,
        cartCount,
        setdefaultAddress,
        defaultAddress,
        setselectedAddressObj}) {
    const [addressType, setaddressType] = useState({
        shipping_address:false,
        billing_address:false
    })
    const [OfferhoverId, setOfferhoverId] = useState('')
    const [ItemPricehoverId, setitemPricehoverId] = useState('');
    const AddressSelection = ({type,selectedAddressObj,toggleSwitch})=>(
        <label htmlFor="checkbox-02" className="text-sm font-normal text-[#555259] pl-2 cursor-pointer mt-[3px] text-left">
            <p>{selectedAddressObj[prod.item_id]?.[type]?.ADDRESS1},</p>
            <p>{selectedAddressObj[prod.item_id]?.[type]?.ADDRESS2},{selectedAddressObj[prod.item_id]?.[type]?.ADDRESS3},{selectedAddressObj[prod.item_id]?.[type]?.ADDRESS4}</p>
            <p>{`${selectedAddressObj[prod.item_id]?.[type]?.CITY}`}-{`${selectedAddressObj[prod.item_id]?.[type]?.POSTAL_CODE}`} ,{`${selectedAddressObj[prod.item_id]?.[type]?.STATE}`}</p>
            <p>{`GSTIN-${selectedAddressObj[prod.item_id]?.[type]?.SITE_GSTIN || '-'}`}</p>
                                      
        </label>
    )
    const handleClose=()=>{
        setaddressType({
            shipping_address:false,
            billing_address:false
        })
                
    }
    const handleToggle=(key)=>{
        handleClose()
        setaddressType((prev)=>({
            ...prev,
            [key]:!addressType[key]

        }))
    }
    const [isOn, setIsOn] = useState(false);
    const toggleSwitch = (key) =>{
        setIsOn(!isOn);
        if(isOn===false){
            const addressCopy={...selectedAddressObj}
            let keys=['billing_address','shipping_address','praposedAmount']
            addressCopy && Object.keys(addressCopy).map((val,i)=>{
                if(!keys.includes(val)){
                    addressCopy[val].billing_address=addressCopy[prod.item_id]?.billing_address;
                    addressCopy[val].shipping_address=addressCopy[prod.item_id]?.shipping_address
                }
            })
            setselectedAddressObj(addressCopy)
        }
    } 
    
    return (
        <motion.div
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: -20 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ ease: 'easeOut', duration: 1 }}>
            <div className="py-3 border-b border-t border-[#CBCBCB] w-full flex items-center flex-wrap lg:px-4 px-0">
                <div className="flex items-center xl:w-[36%] w-full justify-between">
                    <div className='2xl:w-[50%] xl:w-[65%]'>
                        <p className="text-xs3 font-semibold text-[#808285]">List Price</p>
                        <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]"> {Number(prod?.LIST_PRICE)?.toLocaleString('en-IN', {
                            style: 'currency',
                            currency: 'INR',
                        })}</p>
                    </div>
                    <div className='2xl:w-[50%] '>
                        <p className="text-xs3 font-semibold text-[#808285] text-center">Quantity</p>
                        <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E] text-center">{cartCount[prod.item_id]} {prod?.PRIMARY_UOM_CODE}</p>
                    </div>
                </div>
                
                <div className="xl:w-[64%] w-full xl:mt-0 mt-4">
                    <div className='w-full xl:pl-9 flex justify-between items-center'>
                        <div>
                            <p className="text-xs3 font-semibold text-[#808285]">Sub Total</p>
                            <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">
                                {Number(prod?.sub_total)?.toLocaleString('en-IN', {
                                    style: 'currency',
                                    currency: 'INR',
                                })}</p>
                        </div>
                        <div className="xl:ml-5 ml-2.5">
                            <p className="text-xs3 font-semibold text-[#808285]">Discount</p>
                            <p className="text-lg font-semibold text-[#15090E] flex items-center pt-0.5">
                                <>{
                                    Number(prod?.discount_applied||0).toLocaleString('en-IN', {
                                        style: 'currency',
                                        currency: 'INR',
                                    })}
                                </>
                                <span className="ml-1" style={{minWidth:'30px'}}>
                                    <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="left" data-tooltip-trigger="click" type="button">
                                        <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" onMouseEnter={()=>{
                                            setTimeout(() => {
                                                setOfferhoverId(prod.INVENTORY_ITEM_ID)
                                            }, 100);
                                        }} onMouseLeave={()=>{
                                            setTimeout(() => {
                                                setOfferhoverId('')
                                            }, 500);
                                        }}/>
                                    </button>
                                    {OfferhoverId=== prod.INVENTORY_ITEM_ID &&(
                                        <OfferToolTip hover={OfferhoverId=== prod.INVENTORY_ITEM_ID} prod={prod}/>
                                    )}
                                    <OfferToolTip prod={prod} />
                                </span>
                            </p>
                            
                        </div>
                        <div className="xl:ml-5 ml-2.5">
                            <p className="text-xs3 font-semibold text-[#808285]">DAP</p>
                            <p className="text-lg font-semibold text-[#15090E] flex items-center pt-0.5">
                                <>{
                                    Number(prod?.dap||0).toLocaleString('en-IN', {
                                        style: 'currency',
                                        currency: 'INR',
                                    })}
                                </>
                            </p>
                            
                        </div>
                    </div>
                </div>
                <div className="xl:min-w-[284px] w-full bg-[#F5F5FA] rounded-lg text-center py-1.5 mt-4">
                    <p className="text-xs2 font-semibold text-[#808285]">Total Price</p>
                    <div className= "flex items-center justify-center pt-0.5">
                        <p className="md:text-xs4 text-base font-semibold text-[#15090E] mr-2">{Number(prod?.total_price)?.toLocaleString('en-IN', {
                            style: 'currency',
                            currency: 'INR',
                        })}</p>
                        <span>
                            <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" onMouseEnter={()=>{
                                setTimeout(() => {
                                    setitemPricehoverId(prod.INVENTORY_ITEM_ID)
                                }, 100);
                            }} onMouseLeave={()=>{
                                setitemPricehoverId('')
                            }}>
                                <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                            </button>
                            <>
                                {
                                    ItemPricehoverId=== prod.INVENTORY_ITEM_ID &&(
                                        (() => {
                                            const subTotal = Number(prod?.sub_total) || 0;
                                            const totalPrice = Number(prod?.total_price) || 0;
                                            const dap = Number(prod?.dap) || 0;
                                            // Subtract DAP from totalPrice for net discount calculation
                                            const netDiscount = subTotal > 0 ? ((subTotal - totalPrice + dap) / subTotal) * 100 : 0;
                                            return (
                                                <ItemPriceTooltip 
                                                    hover={ItemPricehoverId=== prod.INVENTORY_ITEM_ID} 
                                                    prod={prod} 
                                                    itemPriceValue={totalPrice/prod?.quantity}
                                                    netDiscount={netDiscount}
                                                    onMouseEnter={()=>{
                                                        setitemPricehoverId(prod.INVENTORY_ITEM_ID)
                                                    }}
                                                    onMouseLeave={()=>{
                                                        setitemPricehoverId('')
                                                    }}
                                                />
                                            );
                                        })()
                                    )}
                            </>
                            {(() => {
                                const subTotal = Number(prod?.sub_total) || 0;
                                const totalPrice = Number(prod?.total_price) || 0;
                                const dap = Number(prod?.dap) || 0;
                                // Subtract DAP from totalPrice for net discount calculation
                                const netDiscount = subTotal > 0 ? ((subTotal - totalPrice + dap) / subTotal) * 100 : 0;
                                return (
                                    <ItemPriceTooltip 
                                        prod={prod} 
                                        itemPriceValue={totalPrice/prod?.quantity}
                                        netDiscount={netDiscount}
                                    />
                                );
                            })()}
                        </span>
                    </div>
                </div>
            </div>
            <div className="lg:pl-4 xl:pr-9 px-0">
                {idx===0 &&<div className='flex justify-end pt-3'>
                    <label>
                        <Toggle
                            checked={isOn}
                            icons={false}
                            onChange={toggleSwitch} />
                    </label>
                    <p style={{fontSize:'13px'}} className='ml-2 color-[#090406]'>Use same address for all products</p>
                </div>}
                <div className="flex flex-wrap -mx-6 mt-2">
                    <div className="px-6 lg:w-1/2 w-full">
                        <p className="mb-1.5 text-xs13 font-semibold text-[#808285]">Billing address</p>
                        <div className="dropdown relative">
                            <button
                                onClick={()=>handleToggle('billing_address')} type="button" id="s1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-to h-[108px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5">
                                <img src="images/chevron-red-down1.svg" alt="icon" className="absolute top-1/2 right-5" />
                                {/* {selectedAddressObj[prod.item_id]?.biling_address?.ADDRESS1} */}
                                <div className="relative checkbox custom-checkbox custom-radio3 flex items-center 
                                ">
                                    {/* <input type="radio" id="checkbox-02" name="radiodate" className="cursor-pointer"/> */}
                                    <AddressSelection 
                                        type="billing_address"
                                        prod={prod}
                                        selectedAddressObj={selectedAddressObj}
                                        setselectedAddressObj={setselectedAddressObj}/>
                                </div>
                            </button>
                            <ul className={`dropdown-menu w-full absolute ${addressType.billing_address?'show':'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 py-3 overflow-auto pl-2 pr-3.5 max-h-[150px] scrollbar-menu z-[9999]`} aria-labelledby="s1">
                                <AddressDrop
                                    list={addressDropdown}
                                    type="billing_address"
                                    prod={prod}
                                    toggleSwitch={setIsOn}
                                    selectedAddressObj={selectedAddressObj}
                                    setselectedAddressObj={setselectedAddressObj}
                                    handleClose={handleClose}
                                />
                            </ul>
                        </div>
                    </div>
                    <div className="px-6 lg:w-1/2 w-full lg:mt-0 mt-3">
                        <p className="mb-1.5 text-xs13 font-semibold text-[#808285]">Shipping address</p>
                        <div className="dropdown relative">
                            <button
                                onClick={()=>handleToggle('shipping_address')} type="button" id="s2" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-to h-[108px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5">
                                <img src="images/chevron-red-down1.svg" alt="icon" className="absolute top-1/2 right-5" />
                                <div className="flex items-center ">
                                    {/* <input type="radio" id="checkbox-02" name="radiodate" className="cursor-pointer"/> */}
                                    <AddressSelection
                                        type="shipping_address"
                                        prod={prod}
                                        selectedAddressObj={selectedAddressObj}
                                        setselectedAddressObj={setselectedAddressObj}/>
                                </div>
                            </button>
                            <ul className={`dropdown-menu w-full absolute ${addressType.shipping_address?'show':'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 py-3 overflow-auto pl-2 pr-3.5 max-h-[150px] scrollbar-menu z-[9999]`} aria-labelledby="s1">
                                
                                <AddressDrop list={addressDropdown} type="shipping_address"
                                    prod={prod}
                                    selectedAddressObj={selectedAddressObj}
                                    setselectedAddressObj={setselectedAddressObj}
                                    toggleSwitch={setIsOn}
                                    handleClose={handleClose}/>
                              
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}
